import { useMediaQuery, useTheme } from "@material-ui/core";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import React, { useState } from "react";
import {
	AutocompleteInput,
	Button,
	ReferenceInput,
	SelectInput,
} from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import taxTypes from "../profile/tax_types";
import RangesInput from "./inputs/RangesInput";
import StatusInput from "./inputs/StatusInput";

const Filters = ({ permissions, ...props }) => {
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const [showMore, setShowMore] = useState(false);
	return (
		<SubmitFilters spacerTop={false} {...props}>
			<RangesInput
				source="range"
				alwaysOn
				style={{ marginTop: theme.spacing(4), width: "100%" }}
				fullWidth
			/>
			<StatusInput source="user_payment_status_id" alwaysOn fullWidth />
			{permissions && permissions("admin") && (
				<ReferenceInput
					source="user_id"
					reference="users"
					alwaysOn={!sm}
					fullWidth
					label="resources.user-payments.fields.user_id_id"
					allowEmpty
					emptyText="ra.action.all"
					style={{ width: "100%" }}
				>
					<AutocompleteInput optionText="name" />
				</ReferenceInput>
			)}
			{showMore && permissions && permissions("admin") && (
				<SelectInput
					source="is_approved"
					choices={[
						{ id: 1, name: "ra.action.yes" },
						{ id: 0, name: "ra.action.no" },
					]}
					alwaysOn={!sm}
					fullWidth
					allowEmpty
					emptyText="ra.action.all"
				/>
			)}
			{!showMore && !sm && permissions && permissions("admin") && (
				<Button
					label="ra.action.show_more"
					color="secondary"
					onClick={() => setShowMore(true)}
					style={{ marginBottom: theme.spacing(1) }}
					variant="text"
				>
					<ControlPointIcon />
				</Button>
			)}
			{showMore && !sm && permissions && permissions("admin") && (
				<ReferenceInput
					source="payment_method_id"
					reference="payment-methods"
					fullWidth
					style={{ minWidth: 210 }}
					allowEmpty
					emptyText="ra.action.all"
				>
					<SelectInput optionText="name" fullWidth />
				</ReferenceInput>
			)}
			{showMore && !sm && permissions && permissions("admin") && (
				<SelectInput
					choices={taxTypes}
					source="tax_type"
					fullWidth
					allowEmpty
					emptyText="ra.action.all"
					style={{ minWidth: 180 }}
				/>
			)}
			{showMore && !sm && permissions && permissions("admin") && (
				<SelectInput
					choices={[
						{ id: true, name: "ra.action.yes" },
						{ id: false, name: "ra.action.no" },
					]}
					source="withholding_tax_return"
					fullWidth
					allowEmpty
					emptyText="ra.action.all"
					style={{ minWidth: 250 }}
				/>
			)}
		</SubmitFilters>
	);
};
export default Filters;
